import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Font loading detection
const fontFamilies = ['Poppins', 'Playfair Display', 'Inter', 'JetBrains Mono'];
let fontsLoaded = 0;

const checkFontLoaded = (fontFamily) => {
  return document.fonts ? document.fonts.check(`400 16px "${fontFamily}"`) : true;
};

const handleFontLoad = () => {
  fontsLoaded++;
  if (fontsLoaded >= fontFamilies.length) {
    document.body.classList.add('fonts-loaded');
    document.body.classList.remove('fonts-loading');
  }
};

// Initialize font loading
document.body.classList.add('fonts-loading');

// Check if fonts are already loaded or load them
fontFamilies.forEach(fontFamily => {
  if (checkFontLoaded(fontFamily)) {
    handleFontLoad();
  } else if (document.fonts) {
    document.fonts.load(`400 16px "${fontFamily}"`).then(handleFontLoad);
  } else {
    // Fallback for browsers without font loading API
    setTimeout(handleFontLoad, 100);
  }
});

// Fallback timeout to prevent indefinite loading
setTimeout(() => {
  document.body.classList.add('fonts-loaded');
  document.body.classList.remove('fonts-loading');
}, 3000);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 